import { startOfDay, addYears } from 'date-fns';

export default startOfDay(addYears(new Date(), -2));
